import { useState, useEffect } from 'react';

export const useTypingAnimation = (phrases, typingSpeed = 80, deletingSpeed = 30, pauseDuration = 1500) => {
  const [displayText, setDisplayText] = useState('');
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [isTyping, setIsTyping] = useState(true);
  const [showCursor, setShowCursor] = useState(true);

  useEffect(() => {
    const cursorInterval = setInterval(() => {
      setShowCursor((prev) => !prev);
    }, 530);

    return () => clearInterval(cursorInterval);
  }, []);

  useEffect(() => {
    let timeout;
    const currentPhrase = phrases[phraseIndex];

    if (isTyping) {
      if (displayText === currentPhrase) {
        // Pause before starting to delete
        timeout = setTimeout(() => {
          setIsTyping(false);
        }, pauseDuration);
      } else {
        // Type the next character
        timeout = setTimeout(() => {
          setDisplayText(currentPhrase.slice(0, displayText.length + 1));
        }, typingSpeed);
      }
    } else {
      if (displayText === '') {
        // Move to next phrase
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
        setIsTyping(true);
      } else {
        // Delete a character
        timeout = setTimeout(() => {
          setDisplayText(displayText.slice(0, -1));
        }, deletingSpeed);
      }
    }

    return () => clearTimeout(timeout);
  }, [displayText, isTyping, phraseIndex, phrases]);

  return `${displayText}${showCursor || (displayText !== '' && displayText !== phrases[phraseIndex])? '|' : ' '}`;
};
